import { render, staticRenderFns } from "./StatementTable.vue?vue&type=template&id=57050a66&scoped=true&"
import script from "./StatementTable.vue?vue&type=script&lang=js&"
export * from "./StatementTable.vue?vue&type=script&lang=js&"
import style0 from "./StatementTable.vue?vue&type=style&index=0&id=57050a66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57050a66",
  null
  
)

export default component.exports